<template>
<div>

  <div class="d-inline-flex mr-2">
    <b-input-group :prepend="displayDate" > 
      <b-form-input  id="input-title" :autofocus = "isNew" v-model="issue.title" placeholder="Enter title of issue..." style="color:darkblue; min-width:300px;" maxlength="60" v-on:input="dirty"> </b-form-input>
    </b-input-group>
  </div>
  <div class="d-inline-flex">
      <b-input-group prepend="Status" class="">
        <b-form-select
          class=""
          v-model="issue.status"
          :options="[ 'Open',  'Resolved' ]"
          id="inline-form-custom-select-status"
          v-on:input="dirty"
          style="color:darkblue;"
          >
        </b-form-select>
      </b-input-group>
  </div>

    <b-container class="p-0 mt-3">
    <b-row>
    <b-col cols="4" >
      <div style="min-width:200px;"> 
                  <b-input-group prepend="Type">
                  <div class="border">  
                    <b-form-radio-group
                      stacked
                      class="mx-2 py-2"
                      v-model="issue.issueType"
                      :options="[ 'Internal',  'External' ]"
                      id="inline-form-radio-type"
                      v-on:input="dirty"
                      style="color:darkblue;"
                    >
                    </b-form-radio-group>
                </div>
              </b-input-group> 
    
    </div> 

    </b-col>
   
    <b-col v-if="issue.issueType=='External'">
      <div class="d-inline-flex flex-column ">
        <div class="d-inline bg-light"> Responsible Company </div>  
        <div> <b-form-input id="input-responsible" v-model="issue.responsible" placeholder="Enter company..."  
        maxlength="100" style="color:darkblue;min-width:300px;" v-on:input="dirty"> </b-form-input> </div>        
      </div>
    </b-col>
  </b-row>
  </b-container>

    <div class="d-inline-flex">
         
    </div>

<div class="d-inline-flex"> 

</div>

      <div class="d-flex flex-column ">
        <div class="d-inline bg-light"> Description of issue </div>  
        <b-form-textarea id="input-description" v-model="issue.description" rows="3"  maxlength="1000" style="color:darkblue;" v-on:input="dirty"> </b-form-textarea>
      </div>

          <b-alert variant="danger" v-model="isError"> {{ error }} </b-alert> 

  <div v-if="isNew" class="py-3 px-5" > 

    <span class="float-right"> 
         
     <span class="pr-4"> <b-button @click="$bvModal.hide('NewIssue'+issue.projectId)"> &#10008; Cancel</b-button> </span> 
      <b-button variant="primary" :disabled="!isDirty" v-on:click="add()"> &#10004; Save 
        <b-spinner small  v-if="isBusy"> </b-spinner>
         </b-button>  
    </span>

  </div> 
  
<b-container v-if="!isNew && !isBusy" class="px-1" >

      <b-card no-body class="mb-1 mt-2"> 

        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button @click="updatesVisible = !updatesVisible" id="sectionbutton" block variant="light" size="sm"  class="text-left" >
            <b>Issue Updates</b> <span style="float:right;">{{ issues }}</span>
          </b-button>
        </b-card-header>

        <b-collapse id="issue-updates" v-model="updatesVisible"> 

    <div class="m-2">
         <span class="p-2"> <b-button pill size="sm" v-on:click="addUpdate()"> <strong>+</strong> Update</b-button> </span>
      
      </div>
        <div id="updates">
          <b-table
          responsive
          small
          striped
          outlined
          head-variant="light"
          :busy="isBusy"
          :items="data"
          :fields="fields"
        >
        <template v-slot:table-colgroup="scope">
          <col :key="scope.fields.date" style="width:20%;" >
          <col :key="scope.fields.remarks" style="width:80%;" >
        </template>
        
        <template v-slot:cell(remarks)="data">
          <!-- <span style="white-space:pre;"> {{ data.value }} </span> -->
          <b-form-textarea rows="2" max-rows="4"  plaintext :value="data.value">   </b-form-textarea>
        </template>  

        <template v-slot:cell(date)="data">
          <span class=""> {{ data.value }} </span>
        </template>          

      </b-table>
    </div>

        </b-collapse>

      </b-card>

 </b-container>
      
     <b-modal id="modal-update" @ok="updateOk" hide-header-close title="Update Issue" ok-title="Update">
              
        <div class="p-2"> <b> {{ this.$moment().format("MMMM D, YYYY") }} </b> </div>
        <b-form-textarea id="input-update" autofocus v-model="issueUpdate.Remarks" placeholder="Enter details..." v-on:input="dirtyUpdate" style="color:darkblue;" rows="3"  maxlength="1000" > </b-form-textarea>
   
    </b-modal>     
    
 </div>
</template>

<script>
export default {
  name: 'Issue',
   props:{
     issueId: {
       type:  Number
     },
      issue: {
        type: Object
     }

   },

data: function() {
    return {
        data: [],
        totalRows: 0 , 
        isDirty: false,
        updatesVisible: false,
        isUpdateDirty: false,
        isBusy: false,
        isError: false,
        error: '',
        fields: [
        {
          key: "date",
          sortable: true,
          label: "Date",
          formatter: value => {
              return this.$moment(value).format("MMM D YYYY"); 
          }
        },       
        {
          key: "remarks",
          sortable: false,
          label: "Remarks"
        },
      ],
      
      issueUpdate:
       {
         IssueId: 0,
         ProjectId: "", 
         Date: null,
         Remarks: ""
        }
    }

   },
 
    mounted: function() {
      this.issueUpdate.IssueId = this.issueId;
      this.issueUpdate.ProjectId = this.issue.projectId;
      this.issueUpdate.Date = this.$moment().format("YYYY-MM-DD");
      if (this.issueId!=0){
        this.fetchUpdates();
      }
  },

   methods: {
    
     fetchUpdates() {
       this.isBusy = true;
      this.$auth.acquireToken().then(token => {
        this.$http
          .get("api/IssueUpdates/" + this.issueId, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(response => {
            this.data = response.data;
            this.totalRows = this.data.length;
            this.issue.updateCount = this.data.length;
          })
          .catch(error => {
            this.dataError = true;
            if (error.response) {this.error = error.response.statusText};
          })
          .finally(() => (this.isBusy = false));
      });
    },

      dirty() {
          this.isDirty = true;
          this.$emit("dirty");
       },
       dirtyUpdate() {
         this.isUpdateDirty = true;
       },
       add() {
         this.isBusy = true;
         this.$emit("add", this.issue);
       },       
       updateOk() {
         if (this.isUpdateDirty){
         this.updateIssue(this.issueUpdate);
         }

       },

       addUpdate() {
         //reset before show modal
         this.issueUpdate.Remarks = "";
         this.isUpdateDirty = false;
         this.$bvModal.show("modal-update")
       },

       updateIssue(issueUpdate){
        this.isBusy = true;
        this.$auth.acquireToken().then(token => {
        this.$http
          .post("api/IssueUpdates/", issueUpdate, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(response => {
            //insert new issue into issue list 
            var newUpdate = response.data;
            this.data.splice(0,0,newUpdate);
            this.issue.updateCount = this.data.length;
          })
          .catch(error => {
            this.errored = true;
            if (error.response) {this.error = error.response.statusText};
          })
          .finally(() => {
             this.isBusy = false;
          });
      });     
        
      }       
    
   },

  computed: {
    displayDate: function(){
      return  this.$moment(this.issue.issueDate).format("MMMM D, YYYY"); 
     },

    isNew: function(){
      if (this.issueId == 0){
        return true;
      }
      else{
        return false;
      }
    },
    
    issues: function() {
      if (this.issue.updateCount == 0) {
        return "(none)";
      } else {
        if (this.issue.updateCount == 1) {
          return "(" + this.issue.updateCount + " update)";
        } else {
          return "(" + this.issue.updateCount + " updates)";
        }
      }
    } 
  },

}
</script>

<style scoped>

@media (max-width: 400px) {
    #updates {
    font-size:.875rem;
    }
}

</style>